<template>
    <HeadersAuth/>
    <div class="flex justify-center items-center min-h-screen p-12">
        <div class="max-w-[500px] w-full m-auto bg-white px-12 py-10 shadow-[0_4px_38px_rgba(0,0,0,0.12)] rounded-lg">
            <img src="@/assets/logo.png" alt="logo" class="mx-auto mb-12"/>
            <h1 class="font-semibold text-4xl leading-tight text-[#373737] text-center">Sign In</h1>
            <p class="text-base text-[#575757] pt-4 text-center">Enter your details to login.</p>    
           
            <form class="max-w-6xl" v-on:submit.prevent="onSubmitSignIn" >
                <div class="pt-14">
                    <label class="input-label">Email <span class="text-red-500">*</span></label>
                    <input class="form-control h-[52px] text-[15px] placeholder:text-[15px]" type="email" placeholder="Please enter your email" v-model="state3.email"/>
                    <span v-if="v3$.email.$error" class="error">
                        {{ v3$.email.$errors[0].$message }}
                    </span>
                </div>

                <div class="pt-7">
                    <label class="input-label">Password <span class="text-red-500">*</span></label>
                    <div class="right-icon-input">
                        <input class="form-control h-[52px] text-[15px] placeholder:text-[15px]" :type="hasShow ? 'text' : 'password'" placeholder="Please enter your password" v-model="state3.password"/>
                        <span v-if="v3$.password.$error" class="error">
                            {{ v3$.password.$errors[0].$message }}
                        </span>
                        <div class="absolute top-3.5 right-4 cursor-pointer" @click="hasShow = !hasShow">
                            <i class="text-[#5F6368] far" :class="hasShow ? 'fa-eye' : 'fa-eye-slash'"></i>
                        </div>
                    </div>
                    
                </div>

                <div class="flex justify-between pt-6">
                    <div class="check-box">
                        <input type="checkbox" id="loggedin" />
                        <label for="loggedin" class="text-base leading-5 text-[#7b7b7b] font-medium">Keep me logged in</label>
                    </div>
                    <router-link to="/forgot-password" class="text-[#4696F4] text-[15px] leading-5 font-medium">
                        Forget password?
                    </router-link>
                </div>

                <div class="pt-12">
                    <button type="submit" :disabled="btnLoader" :class="btnLoader == true ? 'opacity-50 cursor-not-allowed' : ''" class="h-[60px] bg-blue-500 rounded text-lg font-semibold p-3 text-white text-center relative block w-full">
                        Sign In
                    </button>
                </div>

                <p class="pt-6 text-center">Not registered yet? <router-link to="/sign-up" class="text-blue-500 font-medium"> Create an Account</router-link></p>
            </form>
        </div>
    </div>
    <!-- <FooterSection/> -->
</template>
<script>
    import HeadersAuth from './HeadersAuth.vue';
    // import FooterSection from './FooterSection.vue';
    import { BASE_URL } from "../../config";
    import axios from "axios";
    import { reactive, computed } from "vue";
    import useValidate from "@vuelidate/core";
    import { required , email} from "@vuelidate/validators";
    import { createToast } from 'mosha-vue-toastify';
    import 'mosha-vue-toastify/dist/style.css';
    import { createLocal } from 'the-storages';

    const mirror = createLocal();
    const storage = mirror._prx;

    export default {
        name: 'LogIn',
        components:{
            HeadersAuth,
            // FooterSection,
        },
        setup() {
            const state3 = reactive({
                email: '',
                password:''
            })
    
            const rules3 = computed(() => {
                return {
                    email: { required, email },
                    password:{ required}

                }
            })
            const v3$ = useValidate(rules3, state3)
            return {
                state3,
                v3$
            }
        },
        data() {
            return {
                btnLoader: false,
                storage: storage,               
                btnSentLoader:false,
                hasShow: false,                         
            }
        },
       
        methods:{       
        
            async onSubmitSignIn() {
                this.btnLoader = true
                this.v3$.$validate(this.v3$.$error);
                console.log("ftftft",this.v3$.$error);
                if (!this.v3$.$error) {

                const formData = {"email": this.state3.email,"password":this.state3.password};
                console.log(formData);
                
                await axios.post(BASE_URL + '/sign-in',formData)
                    .then((response)=>{
                        console.log(response.data.companyDetails);
                        if(response.data.success == 'success'){
                            console.log("Login Auth Console: ",response.data.companyDetails);
                            this.storage.clear();
                            // this.storage.set("companyDetails", response.data.companyDetails);
                            // this.storage.set("company_id", response.data.companyDetails.id);
                            // this.storage.set("ipAddress", this.storage.ipAddress);
                            if(response.data.type=='user' && response.data.user.role.name !== 'General User'){
                                this.tostMessage(response.data.success, response.data.message);
                                this.storage.set("loginType", 'company');
                                this.storage.set("companyDetails", response.data.companyDetails);
                                this.storage.set("company_id", response.data.companyDetails.id);
                                this.storage.set("globalDateFormat", response.data.companyDetails.dateformat);
                                this.storage.set("ipAddress", this.storage.ipAddress);
                                this.storage.set("token", response.data.access_token);
                                this.storage.set("role", response.data.user.role);
                                this.storage.set("userType", response.data.user.role.name);
                                this.storage.set("employeeDetails", response.data.employeeDetails);
                                // alert(JSON.stringify(response.data.user.role, null, 2));

                                // axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.access_token}`;
                                window.location.href = "dashboard/"+response.data.companyDetails.id;
                            } else if (response.data.type=='company') {
                                this.tostMessage(response.data.success, response.data.message);
                                this.storage.set("loginType", 'company');
                                this.storage.set("companyDetails", response.data.companyDetails);
                                this.storage.set("company_id", response.data.companyDetails.id);
                                this.storage.set("globalDateFormat", response.data.companyDetails.dateformat);
                                this.storage.set("ipAddress", this.storage.ipAddress);
                                this.storage.set("token", response.data.access_token);
                                this.storage.set("role", response.data.user.role);
                                this.storage.set("userType", response.data.user.role.name)
                                // axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.access_token}`;
                                window.location.href = "dashboard/"+response.data.companyDetails.id;
                            }else{
                                this.tostMessage('danger', 'You have not access');
                            }
                            this.btnLoader = false
                            // console.log(this.storage);
                        }else{
                            this.tostMessage('danger', response.data.message);
                            this.btnLoader = false
                        }
                    })
                    this.btnLoader = false
                } else {
                    this.btnLoader = false
                    console.log("failure");
                }
            },

            tostMessage(status,message){
                createToast({
                    // title: title,
                    description: message
                },
                {
                    type: status,
                    timeout: 2500,
                    position: 'bottom-right',
                    showIcon: 'true'
                })
            },
        }

    }


</script>